import { useEffect } from 'preact/hooks';
import { applyPack, ensureMaterialsRegistered, resolvePack } from '../lib/skin';

export interface OperatorSkinProps {
  /** The active workspace's vertical (lib/tenant's stored value), or null when
   *  this app never learned it — see that module's flagged gap. */
  vertical: string | null;
}

// Renders nothing. Its ENTIRE job is to tie the pack skin's lifetime to the
// operator shell's, which is the enforcement half of decision ce1c3046:
//
//   • Materials are generated on this component's MOUNT — a deliberate
//     deviation from @vowric/ui's own header, which says "call
//     registerMaterials() once at app start". App start is too early here,
//     because the portal routes return before the shell ever mounts, and an
//     external visitor holding a one-shot link must never pay for (or wear)
//     a company's chassis.
//   • data-pack goes up on mount and comes back OFF on unmount, so signing
//     out, or landing on a portal after a shell session, cannot leave a skin
//     behind on the root element.
export function OperatorSkin({ vertical }: OperatorSkinProps) {
  useEffect(() => {
    ensureMaterialsRegistered();
    return applyPack(resolvePack(vertical));
  }, [vertical]);

  return null;
}
